import { render } from "./TheSlider.vue?vue&type=template&id=bece1fd8&scoped=true"
import script from "./TheSlider.vue?vue&type=script&lang=js"
export * from "./TheSlider.vue?vue&type=script&lang=js"

import "./TheSlider.vue?vue&type=style&index=0&id=bece1fd8&lang=scss&scoped=true"

import exportComponent from "D:\\Диск D старый\\Lessons\\Vuew\\Azbyka\\dobroazbyka\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bece1fd8"]])

export default __exports__